import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { Plugins } from "@capacitor/core";
import Vue2Filters from 'vue2-filters'
const { SplashScreen } = Plugins;
Vue.config.productionTip = false;
Vue.use(Vue2Filters);
new Vue({
  router,
  vuetify,
  mounted() {
    Plugins.StatusBar.setBackgroundColor({
      color: "#274086",
    });
    SplashScreen.hide();
  },
  render: (h) => h(App),
}).$mount("#app");

Plugins.App.addListener("backButton", () => {
  if (window.history.length) {
    router.back();
  }
  Plugins.App.exitApp();
});

const syntaxHighlight = (json):string => {
  if (typeof json != 'string') {
       json = JSON.stringify(json, undefined, 2);
  }
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, function (match) {
      let cls = 'number';
      if (/^"/.test(match)) {
          if (/:$/.test(match)) {
              cls = 'key';
          } else {
              cls = 'string';
          }
      } else if (/true|false/.test(match)) {
          cls = 'boolean';
      } else if (/null/.test(match)) {
          cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
  });
}

Vue.filter("prettyJson", (object:any)=>{
  try {
    if(typeof object === "string"){
      object = JSON.parse(object);
    }
    return syntaxHighlight(object);
  } catch (error) {
    return object
  }
})